export default "__VITE_ASSET__BBUjqdJW__"